const price = {
	mask:    '$ num',
	blocks:  {
		num: {
			mask:               Number,
			min:                0,
			max:                9999999999,
			thousandsSeparator: ',',
			radix:              '.',
		}
	}
};

const percent = {
	mask:    'num %',
	blocks:  {
		num: {
			mask:               Number,
			min:                0,
			max:                100,
			scale:              3,
			signed:             true,
			normalizeZeros:     true,
			radix:              '.',
			thousandsSeparator: ',',
		}
	}
};

const num = {
	mask:    'num',
	blocks:  {
		num: {
			mask:               Number,
			scale:              0,
			thousandsSeparator: ',',
			radix:              '.',
		}
	}
};

const str = {
	mask: String
};

export default payload => {
	switch (payload.mask) {
	case 'price':
		return price;
	case 'percent':
		return percent;
	case 'num':
		return num;
	case 'text':
		return str;
	default:
		return str;
	}
};
